module.exports = __webpack_public_path__ + "img/notice.cb87201a.jpg";